var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Morocco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#d50000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1b5e20",
    d: "M19.45,31l1.737-5.347l-4.544-3.305h5.621L24,17l1.743,5.347h5.615l-4.544,3.305L28.55,31 l-4.544-3.305L19.45,31z M24.971,26.991l1.407,1.027l-0.535-1.662L24.971,26.991z M22.157,26.356l-0.535,1.662l1.407-1.027 L22.157,26.356z M22.525,25.217L24,26.288l1.469-1.071l-0.56-1.724h-1.818L22.525,25.217z M20.153,23.493l1.407,1.021l0.33-1.021 H20.153z M26.11,23.493l0.33,1.021l1.413-1.021H26.11z M23.458,22.347h1.083L24,20.685L23.458,22.347z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Morocco);
export default __webpack_public_path__ + "static/media/icons8-morocco.c276053ad4f847eaef16a85c9caae177.svg";
export { ForwardRef as ReactComponent };